<template>
  <div class="checkbox-cell">
    <input
      :id="$id(underSlugify(label))"
      type="checkbox"
      v-model="computedValue"
    />
    <label :for="$id(underSlugify(label))">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: "CheckboxCell",
  props: {
    value: { type: Boolean, required: true },
    label: { type: String, required: true },
    changeHandler: Function,
    date: String
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.changeHandler(val);
        this.$emit("input", val);
      }
    }
  }
};
</script>

<style scoped></style>
